import { checkValidSession } from '@/unified-modules/account/account-library';
import { Logger } from '@/utilities/logger/datadog/rumEvents/rumEvents';
import { DdEventCategory, DdEventType } from '@/utilities/logger/datadog/types';

/**
 * Applies an external session-refresh signal. The wrapper JWT is treated as the
 * newest auth credential for FGP; Account UM reconciliation runs via
 * checkValidSession + subscribeSession → handleSession when local state lags.
 */
export const refreshExternalAccountSession = async (): Promise<boolean> => {
  Logger.logRumAction({
    name: '[GW][AUTH_UPDATE] External refresh triggered',
    useCase: DdEventCategory.UpdateAuthentication,
    eventType: DdEventType.Info,
    context: {},
  });

  await checkValidSession();

  return true;
};
